import { ApplicationName } from '../../../../types';

import logoAsbestModule from '../../../../assets/logo-asbest-module.svg';
import logoAtlas from '../../../../assets/logo-atlas.svg';
import logoBbm from '../../../../assets/logo-bbm.svg';
import logoBodem from '../../../../assets/logo-bodem.svg';
import logoRapportage from '../../../../assets/logo-rapportage.svg';

export const LOGOS: Record<ApplicationName, string> = {
  asbest: logoAsbestModule,
  atlas: logoAtlas,
  bbm: logoBbm,
  bodem: logoBodem,
  rapportage: logoRapportage,
};

export const BACKGROUND_COLORS: Record<ApplicationName, string> = {
  asbest: 'linear-gradient(to right, #ed8b00, #eea849)',
  atlas: 'linear-gradient(to right, #952f45, #a5364e)',
  bbm: 'linear-gradient(to right, #00b2d5, #0083B0)',
  bodem: 'linear-gradient(to right, #99c558, #a8e063)',
  rapportage: 'linear-gradient(to right, #ee9ca7, #e4aab9)',
};
